import styled from "styled-components";
import FounderImg from "../../../assets/images/image/founder-image-2.webp";
import colors from "../../../theme/color/ColorTheme";
import fontSize from "../../../theme/fonts/FontTheme";

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 100px 0;
  align-items: center;
  background-color: #f8f7f7;
  justify-content: center;
  gap: 80px;
  box-sizing: border-box;
  @media (max-width: 950px) {
    gap: 16px;
    padding: 50px 20px;
    flex-direction: column;
  }
`;

const ImageWrapper = styled.div`
  width: 50%;
  max-width: 550px;
  display: flex;
  justify-content: flex-end;

  @media (max-width: 950px) {
    width: 100%;
  }
`;

const Image = styled.img`
  width: 100%;
  height: auto;

  max-height: 650px;
  object-fit: cover;
  display: block;
`;

const InfoWrapper = styled.div`
  width: 50%;
  gap: 8px;
  display: flex;
  max-width: 550px;
  flex-direction: column;
  justify-content: start;
  @media (max-width: 950px) {
    width: 100%;
  }
`;

const Subtitle = styled.h3`
  font-weight: 400;
  color: ${colors.maroon};
  font-size: ${fontSize.s};
  letter-spacing: 0.04rem;
`;

const Heading = styled.h1`
  font-weight: 400;
  color: ${colors.maroon};
  font-size: ${fontSize.xl};
  letter-spacing: 0.1rem;
`;

const Paragraph = styled.p`
  letter-spacing: 0.04rem;
  line-height: 1.24rem;
  color: ${colors.black};
  font-size: ${fontSize.xs};
`;

function FounderHistory() {
  return (
    <Wrapper>
      <ImageWrapper>
        <Image src={FounderImg} alt="founder-potrait" />
      </ImageWrapper>
      <InfoWrapper>
        <Subtitle>A VISIONARY</Subtitle>
        <Heading>SUPRABHA OJHA</Heading>
        <Paragraph>
          She was born in Kathmandu and raised amidst the rhythm of city life,
          running her manufacturing factory from 2020. Yet during a trip to the
          high Himalayas, she discovered the rare, delicate fibers harvested by
          local artisans a craft that humbled her and taught her patience, care,
          and respect for tradition. Inspired, she devoted herself to creating
          the finest cashmere. Today, she continues her journey with humility,
          honoring heritage, elevating craftsmanship, and preserving the spirit
          of the Himalayas.
        </Paragraph>
      </InfoWrapper>
    </Wrapper>
  );
}

export default FounderHistory;
